import common from '@/store/common/mutations';
import * as types from './mutation-types';

import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

import { SEARCH_PARAMS, RO_APCN_POPUP, PAGING_INFO, CMPN_MST_SEARCH_PARAMS } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.roApcnList = []; //그리드리스트
		state.prcsStepList = []; //조회조건 처리단계
		state.outBoundStatusList = [],
		state.prcsRsltList = []; //조회조건 처리단계
		state.ceqSearchTypeList = []; //조회조건 정비유형
		state.roDdList = []; //조회조건 날짜유형

		state.isMqyStation = false;
	},
	[types.STATE_APCN_INIT]: state => {
		state.roApcnPopUp = RO_APCN_POPUP(); //디테일조회시
		state.saveRoApcn = RO_APCN_POPUP(); //저장시
		state.roApcnSwapPartsList = []; //PWA신청팝업 교환부품정보
		state.roApcnOtherFeeList = [];
		state.roApcnCommentList = []; //审批评论列表
		state.fileList = []; //파일첨부
		state.occuRegnListPop = []; //PWA신청팝업 PWA기초 정보 발생지역
		state.causCdListPop = []; //PWA신청현황 PWA기초 정보 원인코드
		state.ctypeList = []; //PWA신청현황 PWA기초 정보 Ctype
		state.feeTypeList = [];
		state.ceqTypeList = []; //RO신청팝업 정비유형
		state.isDelPwaCompInitFlag = false;
		state.isDelPwaCompInitFlag2 = false;
		state.isDelCamPaignCompInitFlag = false;
		state.isDelCeqDtCompInitFlag = false;
		state.prcStateCd = '';
		state.beRoNo = ''; /*임시저장시 임시로 담아놓은 Rono */
		state.bePrcsStepr = ''; /*임시저장시 임시로 담아놓은 Ro처리단계코드 */
		state.bePrcsStempNmr = ''; /*임시저장시 임시로 담아놓은 Ro처리단계명 */
		state.chkPmcIdCampNoList = '';
		state.selectedPmcId = ''; //차량정보 팝업에서 선택한 pmcId

		state.cmpnMstList = []; //캠페인 목록
		state.opCodeList = []; //op코드 리스트
		state.cmpnPartList = []; //교환부품 리스트
		state.selectedCmpnNm = ''; // 팝업에서 선택한 캠페인명
		state.currentCmpnCd = ''; //선택한 캠페인 코드
		state.currentCmpnNm = ''; //선택한 캠페인 명
		state.currentOpCode = ''; //선택한 op코드
		state.currentOpCoNm = ''; //선택한 op코드명
		state.currentCausPartNo = ''; //선택한 원인부품
		state.currentCausPartNm = ''; //선택한 원인부품명
		state.currentCausCd = ''; //선택한 원인코드
		state.currentPhmnCd = ''; //선택한 현상코드
		state.currentPhmnNm = ''; //선택한 현상코드명
		state.currentCpnyNm = ''; //선택한 협력사명
		state.currentdlvgNm = ''; //선택한 실납품사명
		state.currentMtrlCst = ''; //선택한 자재비
		state.currentWags = ''; //선택한 공임비
		state.currentIncdCst = ''; //선택한 부대비
		state.currentAmt = ''; //선택한 총금액
		state.currentCmpnStdt = ''; //선택한 캠페인 시작일
		state.currentCmpnEndDt = ''; //선택한 캠페인 종료일
		state.popupSelected = []; //팝업에서 선택한 교환부품 리스트
		state.cmpnMstPartSelected = []; //선택한 교환부품 리스트
		state.pwaApcnSelectedList = []; // 선택한 pwa 목록 리스트
		state.cmpnMstSearchParams = CMPN_MST_SEARCH_PARAMS();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.CMPN_MST_SEARCH_PARAMS]: (state, payload) => {
		state.cmpnMstSearchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.RO_APCN_INFO]: (state, { key, value }) => {
		state.roApcnPopUp[key] = value;
	},
	[types.RO_APCN_SAVE_INFO]: (state, { key, value }) => {
		state.saveRoApcn[key] = value;
	},

	/*******************************************얼그레이아이스티 ******************************/

	//팝업 캠페인 목록
	[types.STATE_CMPN_MST_INIT]: state => {
		state.cmpnMstSearchParams = CMPN_MST_SEARCH_PARAMS();
		state.cmpnMstList = [];
		state.opCodeList = [];
		state.cmpnPartList = [];
	},
	[types.STATE_CMPN_OP_CD_INIT]: state => {
		state.opCodeList = [];
		state.cmpnPartList = [];
		state.popupSelected = [];
	}
	/*******************************************얼그레이아이스티 ******************************/
};
